import { restoreFiltersFromStorage } from './utils/filterStorage'

export default () => ({
    // ═══════════════════════════════════════════════
    // ОБЩЕЕ (используется обеими вкладками)
    // ═══════════════════════════════════════════════

    // Список всех категорий для фильтрации.
    // Древовидная структура категорий меню для сайдбара.
    categories: [],
    categoryMap: new Map(),
    isCategoriesLoading: false,

    // Список подразделений
    divisions: [],

    // Текущие активные фильтры.
    filters: restoreFiltersFromStorage(),

    // Список блюд (как в стоп-листе, так и нет) для выбранной категории и фильтров.
    items: [],
    isLoading: false,

    selectedItems: [],
    excludedItemIds: [],

    // ═══════════════════════════════════════════════
    // СТОП-ЛИСТЫ (существующее)
    // ═══════════════════════════════════════════════

    statuses: [
        {
            id: 'all',
            name: 'Все',
        },
        {
            id: 'in_stoplist',
            name: 'В стоп-листе',
        },
        {
            id: 'not_in_stoplist',
            name: 'Не в стоп-листе',
        },
    ],

    reasons: [],
    lastKnownStoppedCount: 0,

    // ═══════════════════════════════════════════════
    // ПЕЧАТЬ БЛЮД (новое)
    // ═══════════════════════════════════════════════

    printManagement: {
        printLocations: [],
        isPrintLocationsLoading: false,
        selectedPrintLocationIds: [],
        workshopMappings: [], // Привязки menu_item_id -> cooking_workshop_ids
        noPrintItemIds: [], // Блюда с отключённой печатью
    },
})
